import type { SalesFunnel } from "@/types/lead";
import type { DealWithStage } from "@/types/deal";

/** Mesma regra do kanban de Leads (`Leads.tsx`). */
export function isIntegrationStyleFunnel(funnel: SalesFunnel | undefined): boolean {
  if (!funnel) return false;
  const isDefault = !!funnel.is_default;
  return !!funnel.integration_id || !isDefault;
}

export function shouldIncludeLegacyNullFunnel(
  funnelId: string | null,
  isDefaultFunnel: boolean,
): boolean {
  return Boolean(funnelId && isDefaultFunnel);
}

export function dealBelongsToFunnel(
  deal: DealWithStage,
  funnelId: string | null,
  isDefaultFunnel: boolean,
  useMembershipPlacement: boolean,
  membershipLeadIds: ReadonlySet<string>,
): boolean {
  if (!funnelId) return true;

  if (!deal.lead_id) {
    return isDefaultFunnel;
  }

  if (useMembershipPlacement) {
    return membershipLeadIds.has(deal.lead_id);
  }

  const leadFunnelId = deal.leads?.funnel_id ?? null;
  if (leadFunnelId === funnelId) return true;
  if (isDefaultFunnel && leadFunnelId === null) return true;
  return false;
}

export function filterDealsByFunnel(
  deals: DealWithStage[],
  funnelId: string | null,
  funnel: SalesFunnel | undefined,
  membershipLeadIds: ReadonlySet<string>,
): DealWithStage[] {
  if (!funnelId) return deals;
  const isDefaultFunnel = !!funnel?.is_default;
  const useMembership = isIntegrationStyleFunnel(funnel);
  return deals.filter(d =>
    dealBelongsToFunnel(d, funnelId, isDefaultFunnel, useMembership, membershipLeadIds),
  );
}

export function dealHasAttributedValue(deal: DealWithStage): boolean {
  const amount = Number(deal.amount);
  return Number.isFinite(amount) && amount > 0;
}
